/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconGitCompare = createReactComponent("git-compare", "IconGitCompare", [
  ["path", { d: "M6 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "svg-0" }],
  ["path", { d: "M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "svg-1" }],
  ["path", { d: "M11 6h5a2 2 0 0 1 2 2v8", key: "svg-2" }],
  ["path", { d: "M14 9l-3 -3l3 -3", key: "svg-3" }],
  ["path", { d: "M13 18h-5a2 2 0 0 1 -2 -2v-8", key: "svg-4" }],
  ["path", { d: "M10 15l3 3l-3 3", key: "svg-5" }]
]);

export { IconGitCompare as default };
//# sourceMappingURL=IconGitCompare.js.map
